// ============================================================
// NAV → MODULE MAP – Map navigation items to permission modules
// ============================================================
// Mỗi route trong sidebar cần biết module nào để check can(module, 'view')

import type { Module } from './permission-matrix.config';

/** Map nav item key → permission module key */
export const navItemModuleMap: Record<string, Module> = {
  // Điều hành
  'dashboard': 'reports',
  'projects': 'projects',
  'pm-dashboard': 'reports',
  'site-manager-dashboard': 'projects',
  'qa-dashboard': 'quality',
  'qs-dashboard': 'reports',
  'secretary-dashboard': 'documents',
  'accountant-dashboard': 'payments',
  'warehouse-dashboard': 'inventory',
  'agro-dashboard': 'inventory',
  'equipment-dashboard': 'equipment_assets',
  'utility-dashboard': 'equipment_assets',
  'zone-ops-dashboard': 'zone_ops',
  'plant-intelligence': 'maintenance_assets',
  'foreman-dashboard': 'maintenance',
  'worker-dashboard': 'maintenance',

  // Thi công
  'boq': 'boq',
  'progress': 'progress',
  'inventory': 'inventory',
  'inventory-groups': 'inventory',
  'payments': 'payments',

  // Chất lượng & duyệt
  'quality': 'quality',
  'approvals': 'approvals',
  'requests': 'inventory',

  // Bảo dưỡng
  'maintenance': 'maintenance',
  'maintenance-work-orders': 'maintenance_work_orders',
  'maintenance-task-catalog': 'maintenance_work_orders',
  'maintenance-assets': 'maintenance_assets',
  'maintenance-plans': 'maintenance_plans',
  'maintenance-schedules': 'maintenance_plans',
  'maintenance-logs': 'maintenance_logs',
  'maintenance-issues': 'maintenance_issues',
  'maintenance-kpis': 'maintenance',
  'maintenance-cost': 'maintenance',
  'maintenance-adv-dashboard': 'maintenance',
  'maintenance-contracts': 'maintenance',
  'maintenance-lifecycle': 'maintenance_assets',
  'maintenance-sla': 'maintenance',
  'maintenance-predictive': 'maintenance',
  'maintenance-bulk': 'maintenance',
  'maintenance-multi-project': 'maintenance',
  'maintenance-compliance': 'maintenance',
  'maintenance-routes': 'maintenance',
  'maintenance-alerts': 'maintenance',

  // Tài nguyên
  'equipment': 'equipment_assets',
  'equipment-groups': 'equipment_assets',
  'export': 'reports',

  // Hệ thống
  'reports': 'reports',
  'onboarding': 'projects',
  'notifications': 'settings',
  'settings': 'settings',

  // Quản trị
  'users': 'users',
  'roles': 'roles',
  'companies': 'users',
  'subscription': 'users',
  'audit-logs': 'audit_logs',
};

/** Lấy module key cho 1 nav item */
export function getModuleForNavItem(itemKey: string): Module | null {
  return navItemModuleMap[itemKey] ?? null;
}
